import React, { useState, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LocationPopup from "./components/LocationPopup";
import Preloader from "./components/Preloader";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopButton from "./components/ScrollToTopButton";

import Home from "./pages/Home";
const About = lazy(() => import("./pages/About"));
const Terms = lazy(() => import("./pages/Terms"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Blogs = lazy(() => import("./pages/Blogs"));
const Feedback = lazy(() => import("./pages/Feedback"));
const ShaktiPeethas = lazy(() => import("./pages/ShaktiPeethas"));
const TempleDetail = lazy(() => import("./pages/TempleDetail"));
const BlogDetail = lazy(() => import("./pages/BlogDetail"));
const Explore = lazy(() => import("./pages/Explore"));
const StateResults = lazy(() => import("./pages/StateResults"));
const Jyotirlingas = lazy(() => import("./pages/Jyotirlingas"));
const CharDhamYatra = lazy(() => import("./pages/CharDhamYatra"));
const AmarnathYatra = lazy(() => import("./pages/AmarnathYatra"));
const PanchaBhootaSthalam = lazy(() => import("./pages/PanchaBhootaSthalam"));
const ArupadaiVeedu = lazy(() => import("./pages/ArupadaiVeedu"));
const MuktiKshetrasKarnataka = lazy(() => import("./pages/MuktiKshetrasKarnataka"));

const isBotOrCrawler = () => {
  if (typeof window === 'undefined' || !window.navigator) return false;
  const userAgent = navigator.userAgent || "";
  const botPattern = /bot|google|baidu|bing|msn|duckduckbot|teoma|slurp|yandex|lighthouse|chrome-lighthouse|headless/i;
  return botPattern.test(userAgent);
};

function App() {
  const [loading, setLoading] = useState(() => {
    if (isBotOrCrawler()) return false;
    try {
      return !sessionStorage.getItem("akhandaa_preloader_shown");
    } catch (e) {
      return true;
    }
  });


  return (
    <Router>
      <ScrollToTop />
      <ScrollToTopButton />
      {loading && (
        <Preloader 
          onComplete={() => {
            try {
              sessionStorage.setItem("akhandaa_preloader_shown", "true");
            } catch (e) {}
            setLoading(false);
          }} 
        />
      )}
      <LocationPopup />

      {/* We hide scrollbars only during the brief loading phase */}
      {!loading && (
        <div className="animate-in fade-in duration-150">
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
              <Route path="/feedback" element={<Feedback />} />
              <Route path="/shakti-peethas" element={<ShaktiPeethas />} />
              <Route path="/explore" element={<Explore />} />
              <Route path="/explore/:state" element={<StateResults />} />
              <Route path="/jyotirlingas" element={<Jyotirlingas />} />
              <Route path="/char-dham-yatra" element={<CharDhamYatra />} />
              <Route path="/amarnath-yatra" element={<AmarnathYatra />} />
              <Route path="/pancha-bhoota-sthalam" element={<PanchaBhootaSthalam />} />
              <Route path="/arupadai-veedu" element={<ArupadaiVeedu />} />
              <Route path="/mukti-kshetras-karnataka" element={<MuktiKshetrasKarnataka />} />
              <Route path="/temple/:name" element={<TempleDetail />} />
            </Routes>
          </Suspense>
        </div>
      )}
    </Router>
  );
}

export default App;

